module.exports = (__webpack_public_path__ || '') + "static/images/photo-8-175101e6c01308b1676d71dab9075224.jpg";